import { render, staticRenderFns } from "./AppFileDropzone.vue?vue&type=template&id=034b5a5f"
import script from "./AppFileDropzone.vue?vue&type=script&lang=ts"
export * from "./AppFileDropzone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports